import { render, staticRenderFns } from "./home-caption4.vue?vue&type=template&id=f784a4c6&"
import script from "./home-caption4.vue?vue&type=script&lang=js&"
export * from "./home-caption4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports